import React, { useState, useEffect } from "react";
import { Box, Modal } from "@mui/material";
import styles from "../otp/otp.module.css";
import { updateProfileThunk, verifyUpdateProfileOtp } from "../../../redux/userSlice";
import { useDispatch } from "react-redux";
import Toastify from "../../../helper/Toastify";
import { unwrapResult } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import api from "../../../helper/Api";


const OtpPopup = ({ open, onClose, loading, error, success, profileData }) => {
  // console.log('profileData=============', profileData);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [countdown, setCountdown] = useState(50);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  const dispatch = useDispatch();
  const nav = useNavigate();

  // Reset OTP and countdown timer when modal opens
  useEffect(() => {
    if (open) {
      setOtp(["", "", "", "", "", ""]);
      setCountdown(600); // Reset countdown timer to 5 seconds for testing
      setIsResendDisabled(true);
    }
  }, [open]);

  // Countdown logic
  useEffect(() => {
    if (open && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 600);

      // Clear interval when countdown ends
      return () => clearInterval(timer);
    } else if (countdown === 0) {
      setIsResendDisabled(false);
    }
  }, [countdown, open]);

  // Resend OTP function
  const handleResendOtp = async () => {
    if (!isResendDisabled) {
      setCountdown(600); // Reset countdown timer to 5 seconds for testing
      setIsResendDisabled(true); // Disable the resend button immediately after clicking

      try {
        // const response = await api.editProfile(profileData);
        // toastify.success("Update succesful");
      } catch (err) {
        console.error("Error updating profile:", err?.message);
        // toastify.error(err?.response?.data?.message || "Something went wrong");
      }
    }
  };

  // Handle OTP input
  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value !== "" && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  // Submit OTP
  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join(""); // Join the OTP digits into a single string

    if (otpValue.length === 6) {
      try {
        const resultAction = await dispatch(verifyUpdateProfileOtp({ otp: otpValue, ...profileData }));
        unwrapResult(resultAction);
        Toastify.success("Update Successful")
        nav("/myprofile");
      } catch (error) {
        if (error?.message?.includes("OTP got expired")) {
          Toastify.error("The OTP has expired. Please request a new one.");
          setIsResendDisabled(false);
        } else {
          // Toastify.error("Invalid OTP or something went wrong.");
        }
      }
    } else {
      Toastify.error("Invalid OTP. Please enter a 6-digit OTP.");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          outline: "none",
          borderRadius: "8px",
        }}
      >
        <div className={styles.login_container}>
          <button className={styles.closeButton} onClick={onClose}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.6841 8.31641L8.31633 23.6842" stroke="#C4C4C4" stroke-width="2" stroke-linecap="round" />
              <path d="M23.6833 23.6855L8.3156 8.3178" stroke="#C4C4C4" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
          <div className={styles.form_section} >

            <div className={styles.form_container} >
              <h2>OTP Verification</h2>
              <div className={styles.number_boxes}>
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    className={styles.box}
                    id={`otp-input-${index}`}
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleInputChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                  />
                ))}
              </div>
              <div style={{ width: "100%", }}>
                <button type="submit" onClick={handleSubmit} className={styles.buttonText}>
                  {"Submit OTP"}
                </button>
              </div>

              {error && <p className={styles.error}>{error}</p>}
              {success && <p className={styles.success}>OTP Verified!</p>}

              <div className={styles.newuser}>
                {isResendDisabled ? (
                  <p>Resend OTP in {formatTime(countdown)}</p>
                ) : (

                  <span className={styles.newuser}>
                    <br />
                    Didn't receive OTP?{" "}
                    <span className={styles.signup} onClick={handleResendOtp}>
                      Resend
                    </span>
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default OtpPopup;
